export default __webpack_public_path__ + "static/media/cp_geo_pn.c568083a.svg";